function handle_collections_main() {
    handle_collection_breadcrumb();
}


function handle_collection_breadcrumb() {
    const breadcrumbPage = window.collectionMetadata?.collection_breadcrumb_page;
    if (!breadcrumbPage?.title || !breadcrumbPage?.url) return;

    const breadcrumbs = document.querySelector('nav.breadcrumbs');
    const homeLink = breadcrumbs.querySelector('a[href="/"]');
    const nextSep = homeLink.nextElementSibling;
    nextSep.remove();
    homeLink.remove();

    const collectionBreadcrumb = breadcrumbs.querySelector('a[href="/collections"], a[href="/pages/back-issues"]');
    collectionBreadcrumb.setAttribute('href', breadcrumbPage.url);
    collectionBreadcrumb.textContent = breadcrumbPage.title;
}